import { Component, OnInit } from '@angular/core'

@Component({
    selector: 'app-top-bar',
    templateUrl: './top-bar.component.html',
    styleUrls: ['./top-bar.component.scss'],
    standalone: false
})
export class TopBarComponent implements OnInit {
  readonly logoUrl =
    'https://images.mailscomafi.com.ar/Comafi/ds/assets/brands/comafi/logo.svg'

  constructor() {}

  ngOnInit() {}
}
